import React, { useState } from 'react';
import ProfileImage from '../img/profileimage.JPG';
import { FaLinkedinIn } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import { FiMenu } from "react-icons/fi";
import './sidebar.scss';

const Sidebar = () => {
	const [isActive, setIsActive] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	
	const UserProfileInfo = [
		{
			id: 1,
			UserName: 'John Doe',
			EmployeeType: 'Frontend Developer',
			Email: 'johndoe@gmail.com',
			Phone: '0123456789',
			DateOfBirth: '01-01-2000',
			From: 'Pune',
			ProfileImage: ProfileImage,
		}
	];
	
	const Buttons = [
		{ id: 1, BtnName: "Info" },
		{ id: 2, BtnName: "Education" },
		{ id: 3, BtnName: "Experience" },
		{ id: 4, BtnName: "Skills" },
		{ id: 5, BtnName: "Projects" },
		{ id: 6, BtnName: "Get In Touch" }
	];
	
	const scrollToSection = (id, index) => {
		setIsActive(index);
		const section = document.getElementById(id);
		if (section) {
			section.scrollIntoView({ behavior: "smooth" });
		}
	};
	
	return (
		<>
			<div className="mobileMenu" onClick={() => setIsOpen(!isOpen)}>
				<FiMenu size={28} />
			</div>
			
			<div className={`mainSidebar ${isOpen ? "open" : ""}`}>
				<div className="subSidebar">
					{UserProfileInfo.map((user) => (
						<div className="Sidebar" key={user.id}>
							<div className="ProfilePhoto">
								<img src={user.ProfileImage} alt="" />
								<p>{user.UserName}</p>
								<span>{user.EmployeeType}</span>
							</div>
							
							<div className="socialurl">
								<span><FaLinkedinIn className="iconDisplay" /></span>
								<span><AiOutlineYoutube className="iconDisplay" /></span>
							</div>
							
							<div className="UserInfo">
								<div className="infoRow">
									<div className="label">Email:</div>
									<span className="userData">{user.Email}</span>
								</div>
								<div className="infoRow">
									<div className="label">Phone:</div>
									<span className="userData">{user.Phone}</span>
								</div>
								<div className="infoRow">
									<div className="label">Date Of Birth:</div>
									<span className="userData">{user.DateOfBirth}</span>
								</div>
								<div className="infoRow">
									<div className="label">From:</div>
									<span className="userData">{user.From}</span>
								</div>
							</div>
							
							<div className="SidebarOption">
								{Buttons.map((button, index) => (
									<button
										key={button.id}
										className={`SideBtn ${isActive === index ? "active" : ""}`}
										onClick={() => scrollToSection(button.BtnName, index)}
									>
										{button.BtnName}
									</button>
								))}
							</div>
							
							<hr className="hrline" />
							<div className="DownloadResume">
								<button>Download Resume</button>
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default Sidebar;
